import api from '../configurations/axios';
import EntryWinnerResult from '../responses/EntryWinnerResult';

export interface EntryWinnerEntry {
    numberOfEntries: number;
    numberOfUsers: number;
}

class EntryWinnersService {
    async addEntryWinners(
        competitionId: number,
        targetCompetitionId: number,
        entries: EntryWinnerEntry[]
    ): Promise<EntryWinnerResult[]> {
        const response = await api.post<EntryWinnerResult[]>(
            `/api/winners/entry-winners/${competitionId}`,
            { targetCompetitionId, entries }
        );
        return response.data;
    }
}

export default new EntryWinnersService();
